import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelativeTimePipe } from 'ZalamoLibrary/src/lib/core/pipes/relative-time-pipe/relative-time.pipe';

@NgModule({
  declarations: [RelativeTimePipe],
  exports: [RelativeTimePipe],
  imports: [CommonModule],
})
export class RelativeTimePipeModule {}
